// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imgBox[data-v-d5ab8c14] {\n  width: 100%;\n  min-height: 300px;\n  background: #eee;\n}", ""]);
// Exports
module.exports = exports;
